import React from "react";

export default function AdmissionStep({
  stepNumber,
  title,
  headingText,
  listItems,
}) {
  return (
    <div className="flex gap-4 md:gap-6 mb-4">
      <div className="w-10 h-10 md:w-[70px] md:h-[70px] rounded-full bg-secondary-normal flex items-center justify-center font-bold font-montserrat text-base md:text-[32px]  text-black">
        {stepNumber}
      </div>
      <div className="flex-1 md:mt-4">
        <h3 className="h-10 font-montserrat font-semibold text-base md:text-lg laptopSm:text-xl text-primary-normal flex items-center mb-4 md:mb-8">
          {title}
        </h3>
        <div className="w-full relative p-6 rounded-[50px] font-notoSans font-light border-[0.5px] border-primary-normal before:w-[2px] before:h-full before:bg-primary-lightActive before:absolute before:-left-9 before:md:left-[-60px] before:top-0 before:rounded-2xl">
          <h1 className="text-base text-black mb-6">{headingText}</h1>
          <ul className="list-disc text-xs leading-6 tracking-[0.04em] pl-4">
            {/* {listItems.map((item, index) => (
              <li key={index}>{item}</li>
            ))} */}
            <li>{listItems}</li>
          </ul>
        </div>
      </div>
    </div>
  );
}
